var map = {
	"./fortuneIcon.svg": 654,
	"./fortuneIconL.svg": 655,
	"./helpdeskIcon.svg": 656,
	"./helpdeskIconL.svg": 657,
	"./homeIcon.svg": 658,
	"./homeIconLarge.svg": 659,
	"./jackpotIcon.svg": 660,
	"./logo.svg": 661,
	"./logoSmall.svg": 662,
	"./loyaltyIcon.svg": 663,
	"./mobileAppIcon.svg": 664,
	"./profileIcon.svg": 665,
	"./questIcon.svg": 666,
	"./rewardLineupIcon.svg": 667,
	"./searchIcon.svg": 668,
	"./searchIconLarge.svg": 669,
	"./signOutIcon.svg": 670,
	"./star.svg": 671,
	"./tournamentIcon.svg": 672,
	"./tournamentLargeIcon.svg": 673,
	"./vipIcon.svg": 674,
	"./wheelIcon.svg": 675,
	"./wheelIconL.svg": 676,
	"./wheelIconMobile.svg": 677
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 653;